import axios from '../axios';

export const all = () => {
  return axios.get('/invena-in-numbers').then(res => res.data);
};

export const update = (payload) => {
  return axios.put(`/invena-in-numbers/${payload.id}`, payload);
};
